import React, { useState, useEffect } from 'react';
import Masters_header from './Masters_header';
import back_arrow from "../../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from 'react-router-dom';
import "../../styles/User.css";
import { User } from 'lucide-react';
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { components } from "react-select";

const UserCreation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isEditMode, setIsEditMode] = useState(false);
  const [userId, setUserId] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [cities, setCities] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [designation, setDesignation] = useState([]);
  const [showDesinationDropdown, setShowDesinationDropdown] = useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [profitCenterOptions, setProfitCenterOptions] = useState([]);
  const [profitCenter, setProfitCenter] = useState([]);
  const [plantCodeOptions, setPlantCodeOptions] = useState([]);
  const [plantCode, setPlantCode] = useState([]);
  const [regions, setRegions] = useState([]);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    employee_id: '',
    designation_id: null,
    designation_label: '',
    email: '',
    password: '',
    confirm_password: '',
    contact_number: '',
    address: '',
    city_id: null,
    city_label: '',
    state_id: null,
    state_label: '',
    country_id: null,
    country_label: '',
    zip_code: '',
    profile_image: null,
    project_ids: [],
    project_selection_type: "",
    region: ""
  });

  useEffect(() => {
    if (location.state?.editData) {
      setIsEditMode(true);
      setUserId(location.state.userId);
      const { editData } = location.state;

      // Populate form with edit data (excluding password fields)
      setFormData({
        first_name: editData.first_name || '',
        last_name: editData.last_name || '',
        employee_id: editData.employee_id || '',
        designation_id: editData.designation_id || null,
        designation_label: editData.designation || '',
        email: editData.email || '',
        password: '', // Don't pre-fill passwords
        confirm_password: '', // Don't pre-fill passwords
        contact_number: editData.contact_number || '',
        address: editData.address || '',
        city_id: editData.city_id || null,
        city_label: editData.city || '',
        state_id: editData.state_id || null,
        state_label: editData.state || '',
        country_id: editData.country_id || null,
        country_label: editData.country || '',
        zip_code: editData.zip_code || '',
        profile_image: editData.profile_image || null,
        image_removed: false,
        project_ids: editData.project_ids || [],
        project_selection_type: editData.project_selection_type || "",
        region: editData.region || "",
      });

      if (editData.user_project_mappings && editData.user_project_mappings.length > 0) {
        try {
          // Create a map to eliminate duplicates by project_id
          const projectMap = new Map();
          editData.user_project_mappings.forEach(mapping => {
            if (!projectMap.has(mapping.project_id)) {
              projectMap.set(mapping.project_id, {
                value: mapping.project_id,
                label: mapping.project_details
              });
            }
          });

          const uniqueProjects = Array.from(projectMap.values());
          setSelectedProjects(uniqueProjects);

          setFormData(prev => ({
            ...prev,
            project_ids: uniqueProjects.map(p => p.value)
          }));
        } catch (error) {
          console.error("Error loading project mappings:", error);
          toast.error("Failed to load project mappings");
        }
      }
      if (editData.project_selection_type === "profit_center") {
        setProfitCenter(
          (editData.profit_centres || []).map(pc => ({
            value: pc.id,
            label: pc.label
          }))
        );
      }
      if (editData.project_selection_type === "plant_code") {
        setPlantCode(
          (editData.plant_codes || []).map(pc => ({
            value: pc.id,
            label: pc.label
          }))
        );
      }
      if (editData.project_selection_type === "region") {
        setRegions(
          (editData.region || []).map(r => ({
            value: r,
            label: r.charAt(0).toUpperCase() + r.slice(1)
          }))
        );
      }
      if (editData.profile_image) {
        setProfileImage(editData.profile_image);
      }
    }
  }, [location.state]);


  const fetchCities = async (term) => {
    try {
      const response = await axiosInstance.get(`/get_city?term=${term}`);
      if (response.data) {
        setCities(response.data.suggestionlist);
        setShowCityDropdown(true);
      }
    } catch (error) {
      toast.error("Failed to fetch cities");
      console.error("Error fetching cities:", error);
    }
  };

  const fetchDesignation = async (term) => {
    try {
      const response = await axiosInstance.get(`/designation/autosuggestion?term=${term}`);
      if (response.data) {
        setDesignation(response.data.autosuggestion);
        setShowDesinationDropdown(true);
      }
    } catch (error) {
      toast.error("Failed to fetch cities");
      console.error("Error fetching cities:", error);
    }
  };

  const handleProjectChange = (selectedOptions) => {
    setSelectedProjects(selectedOptions || []);

    setFormData({
      ...formData,
      project_ids: (selectedOptions || []).map(option => option.value)
    });
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'city_label') {
      fetchCities(value);
    } else if (name === 'designation_label') {
      if (value.length) {
        fetchDesignation(value);
      } else {
        setShowDesinationDropdown(false);
      }
    } else {
      setShowCityDropdown(false);
    }
  };

  const handleCitySelect = (city) => {
    setFormData({
      ...formData,
      city_id: city.value,
      city_label: city.label,
      state_id: city.state_id,
      state_label: city.state_name,
      country_id: city.country_id,
      country_label: city.country_name,
    });
    setShowCityDropdown(false);
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
        setFormData({
          ...formData,
          profile_image: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name.trim()) {
      toast.error("First Name is required");
      return;
    }
    if (!formData.last_name.trim()) {
      toast.error("Last Name is required");
      return;
    }
    if (!formData.employee_id.trim()) {
      toast.error("Employee Id is required");
      return;
    }

    if (!formData.email.trim()) {
      toast.error("Email is required");
      return;
    }


    if (!isEditMode) {
      if (!formData.password.trim()) {
        toast.error("Password is required");
        return;
      }
      if (!formData.confirm_password.trim()) {
        toast.error("Confirm Password is required");
        return;
      }
      if (formData.password !== formData.confirm_password) {
        toast.error("Passwords do not match");
        return;
      }
    }

    if (!formData.project_ids || formData.project_ids.length === 0) {
      toast.error("Project is required");
      return;
    }

    const dataToSubmit = {
      ...formData,
      city_label: undefined,
      state_label: undefined,
      country_label: undefined,
      designation_label: undefined,
      project_ids: formData.project_ids || [],
    };

    delete dataToSubmit.project_selection_type;
    delete dataToSubmit.reference_id;
    delete dataToSubmit.region;

    if (formData.project_selection_type) {
      dataToSubmit.project_selection_type = formData.project_selection_type;

      if (formData.project_selection_type === "profit_center") {
        dataToSubmit.reference_id = profitCenter.map(p => p.value);
      }

      if (formData.project_selection_type === "plant_code") {
        dataToSubmit.reference_id = plantCode.map(p => p.value);
      }

      if (formData.project_selection_type === "region") {
        dataToSubmit.region = regions.map(r => r.value);
      }
    }
    if (isEditMode) {
      delete dataToSubmit.password;
      delete dataToSubmit.confirm_password;
    }

    try {
      if (isEditMode) {
        // For update API
        const response = await axiosInstance.put(`/user/update/${userId}`, dataToSubmit);
        console.log(response);
        if (response.data.success) {
          console.log("Triggering toast with timeout...");
          setTimeout(() => {
            toast.success("User updated successfully");
          }, 100);
        }
      } else {
        // For create API
        const response = await axiosInstance.post('/user/save', dataToSubmit);
        console.log(response);
        if (response.data.success) {
          setTimeout(() => {
            toast.success("User created successfully");
          }, 100);
        }
      }
      navigate('/user');
    } catch (error) {
      console.error("Error:", error);
      toast.error(isEditMode ? "Failed to update user" : "Failed to create user");
      if (error.response && error.response.data) {
        const resData = error.response.data;

        if (resData.error) {
          Object.values(resData.error).forEach((fieldErrors) => {
            fieldErrors.forEach((msg) => toast.error(msg));
          });
        } else if (resData.message) {
          toast.error(resData.message);
        }
      }
    }

  };

  const handleRemoveImage = () => {
    setProfileImage(null);
    setFormData({
      ...formData,
      profile_image: null,
      image_removed: true
    });
  };

  const formTitle = isEditMode ? "Edit User" : "Add User";
  const saveButtonText = isEditMode ? "Update" : "Save";

  const loadProjectOptions = async (inputValue) => {
    try {
      let apiUrl = "";
      let params = {};

      if (inputValue) {
        params.term = inputValue;
      }

      if (formData.project_selection_type) {
        apiUrl = "/projects/get_selectiontype_project_autocomplete";

        let backendType = "";
        switch (formData.project_selection_type) {
          case "plant_code":
            backendType = "plant_code";
            break;
          case "profit_center":
            backendType = "profit_centre";
            break;
          case "region":
            backendType = "region";
            break;
          default:
            backendType = formData.project_selection_type;
        }

        params.type = backendType;

        if (backendType === "profit_centre") {
          if (!profitCenter.length) {
            return [];
          }
          params.reference_id = profitCenter.map(p => p.value);
        }

        if (backendType === "plant_code") {
          if (!plantCode.length) return [];
          params.reference_id = plantCode.map(p => p.value);
        }

        if (backendType === "region") {
          if (!regions.length) {
            return [];
          }
          params.region = regions.map(r => r.value);
        }
      }

      else {
        apiUrl = "/costsolution/projects/autosuggestion";
      }

      const res = await axiosInstance.get(apiUrl, { params });

      const projects = res.data?.autosuggestion || [];

      return projects.map(p => ({
        label: p.label,
        value: p.value
      }));
    } catch (error) {
      console.error("Project suggestion error:", error);
      return [];
    }
  };

  const CustomMenuList = (props) => {
    const { options = [], selectProps } = props;
    const { value = [], onChange } = selectProps;

    const safeOptions = Array.isArray(options) ? options : [];
    const safeValue = Array.isArray(value) ? value : [];

    const allSelected =
      safeOptions.length > 0 && safeValue.length === safeOptions.length;

    const partiallySelected =
      safeValue.length > 0 && safeValue.length < safeOptions.length;

    const toggleSelectAll = () => {
      if (allSelected) {
        onChange([]);
      } else {
        onChange(safeOptions);
      }
    };

    return (
      <components.MenuList {...props}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px",
            borderBottom: "1px solid #e5e7eb",
            background: "#f9fafb",
            position: "sticky",
            top: 0,
            zIndex: 1
          }}
        >
          <input
            type="checkbox"
            checked={allSelected}
            ref={(el) => {
              if (el) el.indeterminate = partiallySelected;
            }}
            onChange={toggleSelectAll}
          />
          <span style={{ fontSize: "12px", fontWeight: 600 }}>
            Select all ({safeValue.length}/{safeOptions.length})
          </span>
        </div>

        {props.children}
      </components.MenuList>
    );
  };

  const CustomOption = (props) => {
    const { isSelected, label } = props;

    return (
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            style={{ accentColor: "#454CF2" }}
          />
          <span>{label}</span>
        </div>
      </components.Option>
    );
  };

  const multiSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '35px',
      borderRadius: '12px',
      fontSize: '13px',
      width: '100%',
      borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
      '&:hover': {
        borderColor: '#454CF2'
      }
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '13px',
      color: '#9AA4B2',
    }),
    container: (base) => ({
      ...base,
      width: '100%'
    }),
    menu: (base) => ({
      ...base,
      fontSize: '13px'
    }),
    menuList: base => ({
      ...base,
      maxHeight: '250px',
      overflowY: 'auto',
      padding: 0
    }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? "#f2f2f2" : "#fff",
      color: "#333",
      cursor: "pointer",
    }),
    valueContainer: (base) => ({
      ...base,
      maxHeight: "35px",
      height: "40px",
      overflowY: "auto",
      overflowX: "hidden",
      flexWrap: "wrap",
      alignItems: "center",
      paddingTop: "4px",
      paddingBottom: "4px",
    }),
  };

  const loadProfitCenters = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get("/projects/get_profit_centre",
        { params: { term: inputValue || "" } }
      );

      const options = (res.data?.autosuggestion || []).map(item => ({
        value: item.value,
        label: item.label
      }));
      if (!inputValue) {
        setProfitCenterOptions(options);
      }

      callback(options);
    } catch (err) {
      console.error("Profit center error", err);
      callback([]);
    }
  };

  const loadPlantCode = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get("/plant_code/autosuggestion",
        { params: { term: inputValue || "" } }
      );

      const options = (res.data?.autosuggestion || []).map(item => ({
        value: item.value,
        label: item.label
      }));
      if (!inputValue) {
        setPlantCodeOptions(options);
      }
      callback(options);
    } catch (err) {
      console.error("Profit center error", err);
      callback([]);
    }
  };

  const projectSelectKey = `${formData.project_selection_type}-${(profitCenter || []).map(p => p.value)}-${(plantCode || []).map(p => p.value)}-${(regions || []).map(r => r.value)}`;

  const validateProjectDependency = () => {

    if (formData.project_selection_type === "plant_code" && !plantCode.length) {
      toast.warning("Please select Plant Code first");
      return false;
    }

    if (formData.project_selection_type === "profit_center" && !profitCenter.length) {
      toast.warning("Please select Profit Centre first");
      return false;
    }

    if (formData.project_selection_type === "region" && !regions.length) {
      toast.warning("Please select Region first");
      return false;
    }

    return true;
  };

  return (
    <>
      <Masters_header onSearch={null} disableSearch={true} />
      <div className='user-creation'>
        <div className="project_popup_header">
          <div className="project_popup_header_left">
            <img src={back_arrow} alt="Back Arrow" onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }} />
            <p style={{ fontSize: '14px' }} className="new_cost_line">{formTitle}</p>
          </div>
          <div className="project_popup_header_right">
            <button style={{ fontSize: '12px', width: '80px', height: '35px' }} className="cancel_btn" onClick={() => navigate(-1)}>
              Cancel
            </button>
            <button
              style={{ fontSize: '12px', width: '80px', height: '35px' }}
              className="save_btn"
              onClick={handleSubmit}
            >
              {saveButtonText}
            </button>
          </div>
        </div>

        <div className="user-creation-form-container">
          <h1 className="user-creation-form-title">{formTitle}</h1>
          <p className="user-creation-form-subtitle">{isEditMode ? "Edit the details for given fields" : "Enter the details for given fields to configure the user"}</p>

          <form onSubmit={handleSubmit}>
            <div className="user-creation-form-grid">
              {/* First Column */}
              <div>
                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">First name  <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type=""
                    name="first_name"
                    placeholder="First name"
                    className="user-creation-form-input"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Employee ID  <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type=""
                    name="employee_id"
                    placeholder="Enter here..."
                    className="user-creation-form-input"
                    value={formData.employee_id}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Email  <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter here..."
                    className="user-creation-form-input"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                {!isEditMode && (
                  <>
                    <div className="user-creation-form-field password-field" style={{ position: 'relative' }}>
                      <label className="user-creation-form-label">
                        Confirm Password <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type={showConfirmPassword ? "" : "password"}
                        name="confirm_password"
                        placeholder="Enter password"
                        className="user-creation-form-input"
                        value={formData.confirm_password}
                        onChange={handleChange}
                        required
                      />
                      {showConfirmPassword ? (
                        <FaEyeSlash
                          onClick={() => setShowConfirmPassword(false)}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '68%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#454CF2',
                          }}
                        />
                      ) : (
                        <FaEye
                          onClick={() => setShowConfirmPassword(true)}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '68%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#19324C',
                          }}
                        />
                      )}
                    </div>
                  </>
                )}

                {formData.project_selection_type === "region" && (
                  <div className="user-creation-form-field">
                    <label className="user-creation-form-label">
                      Region
                    </label>

                    <Select
                      isMulti
                      value={regions}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      onChange={(selected) => setRegions(selected || [])}
                      options={[
                        { label: "East", value: "east" },
                        { label: "West", value: "west" },
                        { label: "South", value: "south" },
                        { label: "North", value: "north" }
                      ]}
                      placeholder="Select Region"
                      components={{
                        MenuList: CustomMenuList,
                        Option: CustomOption
                      }}
                      styles={multiSelectStyles}
                    />
                  </div>
                )}

                {formData.project_selection_type === "profit_center" && (
                  <div className="user-creation-form-field">
                    <label className="user-creation-form-label">
                      Profit Centre
                    </label>
                    <AsyncSelect
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      value={profitCenter}
                      loadOptions={loadProfitCenters}
                      onChange={(selected) => setProfitCenter(selected || [])}
                      placeholder="Search Profit Center..."
                      cacheOptions
                      defaultOptions={profitCenterOptions}
                      onFocus={() => {
                        if (profitCenterOptions.length === 0) {
                          loadProfitCenters("", () => { });
                        }
                      }}
                      isClearable
                      styles={multiSelectStyles}
                      components={{
                        MenuList: CustomMenuList,
                        Option: CustomOption
                      }}
                    />
                  </div>
                )}

                {formData.project_selection_type === "plant_code" && (
                  <div className="user-creation-form-field">
                    <label className="user-creation-form-label">Plant Code</label>

                    <AsyncSelect
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      value={plantCode}
                      loadOptions={loadPlantCode}
                      onChange={(selected) => setPlantCode(selected || [])}
                      placeholder="Search Plant Code..."
                      cacheOptions
                      defaultOptions={plantCodeOptions}
                      onFocus={() => {
                        if (plantCodeOptions.length === 0) {
                          loadPlantCode("", () => { });
                        }
                      }}
                      isClearable
                      styles={multiSelectStyles}
                      components={{
                        MenuList: CustomMenuList,
                        Option: CustomOption
                      }}
                    />
                  </div>
                )}


                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Mobile number</label>
                  <input
                    type="tel"
                    name="contact_number"
                    placeholder="Enter here..."
                    className="user-creation-form-input"
                    value={formData.contact_number}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Address</label>
                  <input
                    type=""
                    name="address"
                    placeholder="Enter here..."
                    className="user-creation-form-input"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Country</label>
                  <input
                    type=""
                    name="country_label"
                    placeholder="Will auto-populate from city"
                    className="user-creation-form-input"
                    value={formData.country_label}
                    onChange={handleChange}
                    readOnly
                    required
                  />
                </div>
              </div>

              {/* Second Column */}
              <div>
                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Last name  <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type=""
                    name="last_name"
                    placeholder="Last name"
                    className="user-creation-form-input"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Designation</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type=""
                      name="designation_label"
                      placeholder="Start typing to search designations..."
                      className="user-creation-form-input"
                      value={formData.designation_label}
                      onChange={(e) => handleChange({ target: { name: 'designation_label', value: e.target.value } })}
                      onFocus={() => {
                        if (formData.designation_label.length > 0) {
                          fetchDesignation(formData.designation_label);
                        }
                      }}
                      required
                    />
                    {showDesinationDropdown && designation.length > 0 && (
                      <div className="designation-dropdown" style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 10,
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        maxHeight: '150px',
                        overflowY: 'auto',
                        fontSize: '12px'
                      }}>
                        {designation.map(desig => (
                          <div
                            key={desig.value}
                            style={{
                              padding: '8px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #eee'
                            }}
                            onClick={() => {
                              setFormData({
                                ...formData,
                                designation_id: desig.value,
                                designation_label: desig.label
                              });
                              setShowDesinationDropdown(false);
                            }}

                          >
                            {desig.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {!isEditMode && (
                  <>
                    <div className="user-creation-form-field password-field" style={{ position: 'relative' }}>
                      <label className="user-creation-form-label">
                        Password <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type={showPassword ? "" : "password"}
                        name="password"
                        placeholder="Enter password"
                        className="user-creation-form-input"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      {showPassword ? (
                        <FaEyeSlash
                          onClick={() => setShowPassword(false)}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '68%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#454CF2',
                          }}
                        />
                      ) : (
                        <FaEye
                          onClick={() => setShowPassword(true)}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '68%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',

                            color: '#19324C',
                          }}
                        />
                      )}
                    </div>
                  </>
                )}

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">
                    Project Selection Type
                  </label>

                  <div className="pill-radio-group">
                    {[
                      { label: "Plant Code", value: "plant_code" },
                      { label: "Profit Center", value: "profit_center" },
                      { label: "Region", value: "region" }
                    ].map(item => (
                      <label
                        key={item.value}
                        className={`pill-radio ${formData.project_selection_type === item.value ? "active" : ""
                          }`}
                      >
                        <input
                          type="radio"
                          name="project_selection_type"
                          checked={formData.project_selection_type === item.value}
                          onClick={() => {
                            const isSame = formData.project_selection_type === item.value;

                            setFormData(prev => ({
                              ...prev,
                              project_selection_type: isSame ? "" : item.value,
                              project_ids: []
                            }));
                            setProfitCenter([]);
                            setPlantCode([]);
                            setRegions([]);
                            setSelectedProjects([]);
                          }}
                        />

                        <span className="pill-label">{item.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">Project  <span style={{ color: 'red' }}>*</span></label>

                  <AsyncSelect
                    isMulti
                    key={projectSelectKey}
                    cacheOptions
                    defaultOptions={true}
                    loadOptions={loadProjectOptions}
                    value={selectedProjects}
                    onChange={handleProjectChange}
                    placeholder="Search project..."
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onMenuOpen={() => {
                      validateProjectDependency();
                    }}
                    components={{
                      MenuList: CustomMenuList,
                      Option: CustomOption
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "40px",
                        borderRadius: "12px",
                        fontSize: "13px",
                        borderColor: state.isFocused ? "#454CF2" : "#DCDFE4",
                        boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: "40px",
                        height: "40px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        flexWrap: "wrap",
                        alignItems: "center",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                      }),
                      option: (base, { isFocused }) => ({
                        ...base,
                        backgroundColor: isFocused ? "#f2f2f2" : "#fff",
                        color: "#333",
                        cursor: "pointer",
                      }),
                      menu: base => ({
                        ...base,
                        zIndex: 999,
                        fontSize: '12px',
                        marginTop: '4px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                      }),
                      menuList: base => ({
                        ...base,
                        maxHeight: '250px',
                        overflowY: 'auto',
                        padding: 0
                      }),
                    }}
                  />

                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">City</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type=""
                      name="city_label"
                      placeholder="Start typing to search cities..."
                      className="user-creation-form-input"
                      value={formData.city_label}
                      onChange={handleChange}
                      onFocus={() => {
                        if (formData.city_label.length > 0) {
                          fetchCities(formData.city_label);
                        }
                      }}
                      required
                    />
                    {showCityDropdown && cities.length > 0 && (
                      <div className="city-dropdown" style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 10,
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        maxHeight: '150px',
                        overflowY: 'auto',
                        fontSize: '12px'
                      }}>
                        {cities.map(city => (
                          <div
                            key={city.value}
                            style={{
                              padding: '8px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #eee'
                            }}
                            onClick={() => handleCitySelect(city)}
                          >
                            {city.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="user-creation-form-field">
                  <label className="user-creation-form-label">State</label>
                  <input
                    type=""
                    name="state_label"
                    placeholder="Will auto-populate from city"
                    className="user-creation-form-input"
                    value={formData.state_label}
                    onChange={handleChange}
                    readOnly
                    required
                  />
                </div>
              </div>

              {/* Profile Image Section */}
              <div className="profile-section">
                <div className="profile-avatar">
                  {profileImage ? (
                    <>
                      <img src={profileImage} style={{ width: '120px', height: '120px' }} alt="Profile" className="profile-icon" />
                      <button
                        type="button"
                        className="remove-image-btn"
                        onClick={handleRemoveImage}
                      >
                        Remove
                      </button>
                    </>
                  ) : (
                    <User className="profile-icon" />
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="file-input"
                  style={{ display: 'none' }}
                  id="profile-image-input"
                />
                <label htmlFor="profile-image-input" className="upload-button">
                  {profileImage ? "Change profile image" : "Upload profile image"}
                </label>
              </div>

              {/* Zip code - Full Width */}
              <div className="user-creation-form-field zip-code-field">
                <label className="user-creation-form-label">Zip code</label>
                <input
                  type=""
                  name="zip_code"
                  placeholder="Enter here..."
                  className="user-creation-form-input"
                  value={formData.zip_code}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
};

export default UserCreation;